import { useNavigate } from 'react-router-dom';

const config = [
  { title: 'Регистрация в приложении', amount: 100 },
  { title: 'Приглашение друга (за каждого)', amount: 350 },
  { title: 'Взаимная симпатия', amount: 25 },
  { title: '4 фотографии в профиле', amount: 100 },
  { title: 'Добавление аудио визитки', amount: 50 },
  { title: 'Первое сообщение после взаимной симпатии', amount: 20 },
  { title: 'Покупка подарков (за каждый)', amount: 20 },
  { title: 'Просмотр трансляций в течении 15 минут (ежедневное вознаграждение)', amount: 60 },
  { title: 'Покупка MYTA Premium', amount: '20 000' }
];

function MytaIdea() {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full">
      <div
        className="w-[100%] h-[81px] flex justify-center items-center bg-[#010d0d] sticky top-0 left-0 z-50"
        style={{ borderBottom: '1px solid #233636' }}
        onClick={() => {
          navigate(-1);
        }}
      >
        <img src="/icons/Button-back.svg" alt="" className="w-[44px] absolute top-[20px] left-[16px]" />
        <img src="/logo1.svg" className="w-[134px] my-[19px]" alt="" />
      </div>
      <div className="flex flex-col w-full  pt-10 px-4 bg-gradient-to-b from-[#010d0d] to-[#132f32] pb-6">
        <p className="font-bold text-lg text-white mb-3">Рады видеть тебя в MYTA!</p>
        <p className="text-white">
          Наше приложение помогает не просто найти пару, но и провести идеальный вечер в реальном мире.
        </p>

        <p className="text-white">
          За каждую активность в приложении ты получаешь очки
          <img className="w-[18px] h-[18px] inline ml-1" src="/icons/myta-coin.svg" alt="myta-coin" />
        </p>

        <p className="text-white mb-3">
          <span className="font-bold">Скоро</span> накопленные очки можно будет обменивать на скидки и оплачивать до
          100% счета в лучших заведениях-партнёрах: кафе, ресторанах, кино и барах!
        </p>
        <img className="w-full max-h-[262px] mb-6" src="/images/myta-idia.png" alt="myta" />
        <p className="font-bold text-lg text-white mb-3">За что начисляются очки активности:</p>
        <div className="space-y-1.5 mb-6">
          {config.map((item, index, array) => (
            <div
              key={index}
              className={`flex items-start justify-between gap-1 pb-1.5 text-white ${array.length - 1 !== index ? 'border-b border-white/30' : ''}`}
            >
              <p>{item.title}</p>
              <p className="font-bold flex items-center gap-1 truncate min-w-0 shrink-0">
                +{item.amount}
                <img className="size-[18px] shrink-0" src="/icons/myta-coin.svg" alt="myta-coin" />
              </p>
            </div>
          ))}
        </div>
        <p className="font-bold text-lg text-white">Благодарим за выбор MYTA ❤️</p>
      </div>
    </div>
  );
}

export default MytaIdea;
